export function isSafari () {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}



// WEBPACK FOOTER //
// ./src/templates/shared/utils.js